export default {
  messages: {
    en: {
      noLenders: 'There are no lenders to show at present.',
    },
  },
}
